if (!customElements.get('included-products')) {
  class IncludedProducts extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector('.included-products__carousel');
      this.addEventListener('click', this.onClick.bind(this));
      this.initSlider();
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initSlider() {
      if (!this.carousel || this.swiper) return;

      // Swiper is a deferred script — retry once it has run
      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', () => this.initSlider(), { once: true });
        return;
      }

      this.swiper = new Swiper(this.carousel, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        breakpoints: {
          750: { spaceBetween: 24 }
        },
        speed: 500,
        watchOverflow: true,
        pagination: {
          el: this.querySelector('.included-products__pagination'),
          clickable: true
        },
        navigation: {
          prevEl: this.querySelector('.included-products__arrow--prev'),
          nextEl: this.querySelector('.included-products__arrow--next')
        }
      });
    }

    async onClick(event) {
      const button = event.target.closest('[data-included-atc]');
      if (!button || button.disabled) return;

      event.preventDefault();

      const variantId = button.dataset.variantId;
      if (!variantId || button.classList.contains('loading')) return;

      const sellingPlan = button.dataset.sellingPlan;
      const item = { id: variantId, quantity: 1 };
      if (sellingPlan) item.selling_plan = sellingPlan;

      button.classList.add('loading');

      /*
       * Rebuy SmartCart owns the cart drawer on this store and only notices
       * XHR/form adds, so a fetch add leaves it stale. Where it is absent the
       * theme's own cart-notification takes over, and that one needs the
       * rendered sections in the add response.
       */
      const rebuy = window.Rebuy;
      const smartCart = rebuy && rebuy.SmartCart;
      const cartNotification = smartCart ? null : document.querySelector('cart-notification');
      const body = { items: [item] };

      if (cartNotification) {
        body.sections = cartNotification.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      try {
        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || error.message || 'Failed to add item to cart');
        }

        // fetchCart re-renders the drawer; show() is the call global.js already uses
        if (smartCart) {
          if (rebuy.Cart) rebuy.Cart.fetchCart();
          smartCart.show();
        } else if (cartNotification) {
          const parsedState = await response.json();

          if (parsedState.sections) {
            cartNotification.productJustAddedToCart(parsedState);
          } else {
            cartNotification.productJustAddedToCartByQuickAdd();
          }
        }
      } catch (error) {
        console.error('Included products add to cart:', error);
      } finally {
        button.classList.remove('loading');
      }
    }
  }

  customElements.define('included-products', IncludedProducts);
}
